export class DialogModelCollectRetailerOutstanding {
    constructor(
        public invoiceData: any
    ) {}
  }
  